<template>
  <div style="width: 100%">
    <div class="list-usaha">
      <div class="list-usaha-content list-usaha-content__title" style="margin-bottom: 0 !important">
        <p v-for="(table, index) in filteredTables" :key="index" :class="table.css">
          {{ table.name }}
        </p>
      </div>
      <div v-if="Number(listAvailable(tingkatResiko)) > 0">
        <div v-for="(list, index) in listInput" :key="index">
          <div v-if="showForm(list.subname, tingkatResiko)">
            <div class="list-usaha-content" style="margin-top:5px">
              <p v-for="(table, i) in filteredTables" :key="i" :class="table.css" style="overflow: visible;">
                <span v-if="table.input">
                  <div v-if="table.type == 'file'">
                    <div>
                      <label v-if="is_sipm_validation && sipm_preview" class="pointer" @click="
          downloadFile(
            $store.state[storeName][list.fileStore]['path']
          )
          ">
                        <i class="fas fa-download"></i>
                        {{
          $get(
            $store,
            `state.${storeName}.${list.fileStore}.original_name`,
            '-'
          )
        }}
                      </label>
                    </div>

                    <label class="btn btn-default btn-file" v-if="$store.state.kplhStore.is_vendor_feedback">
                      <i class="fas fa-upload"></i>
                      <input type="file" style="display: none;"
                        v-on:change="fileChangeHandler($event, list.fileStore)" />
                      <span class="all-column">
                        {{
          $get(
            $store,
            `state.${storeName}.${list.fileStore}.original_name`,
            'Upload'
          )
        }}
                      </span>
                    </label>
                    <label v-else class="pointer" @click="
        downloadFile(
          $store.state[storeName][list.fileStore]['path']
        )
          ">
                      <i class="fas fa-download"></i>
                      {{
          $get(
            $store,
            `state.${storeName}.${list.fileStore}.original_name`,
            '-'
          )
        }}
                    </label>
                  </div>
                  <!-- <input
                    style="width: 90%"
                    :type="table.type"
                    v-model="$store.state[storeName][list.inputStore]"
                    v-if="table.type == 'text'"
                    :disabled="disabled"
                  /> -->
                  <textarea rows="1" style="width: 90%" :type="table.type"
                    v-model="$store.state[storeName][list.inputStore]" 
                    v-if="table.type == 'text'"
                    :disabled="!is_hse_validation" />

                  

                  <div v-if="table.type == 'internal' && !is_vendor_validation">
                    <textarea rows="1" style="width: 90%" :type="table.type"
                      v-model="$store.state[storeName][list.internalNoteStore]" :maxlength="255"
                      :disabled="!is_head_validation" />
                  </div>

                  <div v-if="table.obj_name == 'note'" class="character-count">
                    ({{ $store.state[storeName][list.inputStore].length }}/255)
                  </div>

                  <div v-if="table.type == 'internal' && !is_vendor_validation" class="character-count">
                    ({{ $get($store.state, `${storeName}.${list.internalNoteStore}`, 0).length}}/255)
                  </div>

                  <select style="width:90%;height:100%" name="" id=""
                    v-model="$store.state[storeName][list.optionStore]" v-if="table.type == 'select'" :disabled="disabled || $store.state.kplhStore.is_vendor_feedback
          ">
                    <option style="text-align:center" v-for="(option, index) in list.options" :key="index">{{ option }}
                    </option>
                  </select>
                </span>

                <span v-else>
                  {{ list[table.type] }}
                  <div v-if="table.type === 'name'" class="tooltip-container">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#51a8cf" style="width: 20px;">
                      <path fill-rule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clip-rule="evenodd" />
                    </svg>
                    <div class="tooltip-text" v-html="list.tooltipText"></div>
                  </div>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="mb10 mt10" style="color: red">
          Untuk Tingkat Risiko yang Anda Pilih Tidak Ada Pertanyaan pada
          Kategori Ini
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import BlockLabelGray from './label/blockLabel-gray.vue'
import InputArea from './input/input-area.vue'

import axios from 'axios'
import { api_lp, api } from '@/services/config'
export default {
  props: [
    'label',
    'isRequired',
    'tables',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'listInput',
    'disabled',
  ],
  components: { BlockLabelGray, InputArea },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {
    tingkatResiko() {
      return this.$tingkatResikoValue()
    },
    is_sipm_validation() {
      return this.$store.state.kplhStore.is_sipm_validation
    },
    sipm_preview() {
      return this.$store.state.kplhStore.sipm_preview
    },
    is_hse_validation() {
      const is_hse = this.$route.path.indexOf('kplh-hse-validation') != -1
      return is_hse
    },
    is_head_validation() {
      const is_hse_head = this.$route.path.indexOf('kplh-head-validation') != -1
      return is_hse_head
    },
    is_vendor_validation() {
      const is_vendor = this.$route.path.indexOf('kplh-landingpage') != -1
      return is_vendor
    },
    filteredTables() {
      if (this.is_vendor_validation) {
        // Jika is_vendor_validation true, buang elemen terakhir dari array tables
        return this.tables.slice(0, -1);
      } else {
        // Jika is_vendor_validation false, kembalikan seluruh array tables
        return this.tables;
      }
    }
  },
  methods: {
    fileChangeHandler(e, tableField) {
      let fileUpload = Array.from(e.target.files)
      let fileType = fileUpload[0].type
      let fileName = fileUpload[0].name


      fileUpload['file'] = fileUpload
      fileUpload['fileName'] = fileUpload[0].name

      if (
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi) >= 0 ||
        fileName.search(/.rar/gi) >= 0
      ) {

        this.uploadFile(fileUpload[0], tableField)
      } else {
        alert('Jenis File ini tidak dapat di upload')
      }
    },
    async uploadFile(file, tableField) {
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const url = `${api_lp}/api/v1/vendor/kplh-dokument`

        let bodyFormData = new FormData()
        bodyFormData.append(
          'request_id',
          this.$store['state'][this.storeName]['request_id']
        )
        bodyFormData.append('tableField', tableField)
        bodyFormData.append('kplh_document_lampiran[]', file)

        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data.status == 'success') {
          this.$store.commit(this.mutationName, {
            name: tableField,
            value: [],
          })
          this.$store.commit(this.mutationName, {
            name: tableField,
            value: data.data,
          })
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
    showForm(origin, value) {
      value = value.toLowerCase()
      origin = origin.toLowerCase()

      if (value == 'kritis') {
        switch (origin) {
          case 'kritis':
            return true
            break
          case 'tinggi':
            return true
            break
          case 'sedang':
            return true
            break
          case 'rendah':
            return true
            break

          default:
            return false
            break
        }
      }
      if (value == 'tinggi') {
        switch (origin) {
          case 'tinggi':
            return true
            break
          case 'sedang':
            return true
            break
          case 'rendah':
            return true
            break

          default:
            return false
            break
        }
      }
      if (value == 'sedang') {
        switch (origin) {
          case 'sedang':
            return true
            break
          case 'rendah':
            return true
            break

          default:
            return false
            break
        }
      }
      if (value == 'rendah') {
        switch (origin) {
          case 'rendah':
            return true
            break

          default:
            return false
            break
        }
      }

      return false
    },
    listAvailable(tingkatResiko) {
      const list = this.listInput
      let availableCount = 0
      const count = list.map(item => {
        if (this.showForm(item.subname, tingkatResiko)) availableCount += 1
      })

      return availableCount
    },
    async downloadFile(link) {
      if (link) {
        let linkUrl = `${api_lp}/kplh-file/${link}`
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  z-index: 9999999999;
  width: 300px;
  height: fit-content;
  /* background-color: #333; */
  /* color: #fff; */
  background-color: #fff;
  color: #343a40;
  box-shadow: 1px 2px 6px 5px rgba(0, 0, 0, 0.5);
  /* text-align: center; */
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  bottom: 110%;
  left: 150%;
  /* left: 50%; */
  /* transform: translateX(-50%); */
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: normal;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.character-count {
  font-size: x-small;
  margin-bottom: 0;
  float: right;
  margin-right: 20px;
}
</style>
